import React, { useState, useEffect, useRef } from 'react';
import AudioPlayer from 'react-audio-player';
import './MusicPlayer.css'; 

const MusicPlayer = () => {
  const [currentTrackIndex, setCurrentTrackIndex] = useState(0);
  const audioRef = useRef(null);
  const musicList = ['music1.mp3', 'music2.mp3', 'music3.mp3','music4.mp3','music5.mp3'];

  // Function to play next track
  const playNextTrack = () => {
    setCurrentTrackIndex((prevIndex) => 
      prevIndex + 1 >= musicList.length ? 0 : prevIndex + 1
    );
  };

  // Effect to handle autoplay and track change
  useEffect(() => {
    if (audioRef.current) {
      const player = audioRef.current.audioEl.current;
      player.play().catch((error) => console.error('Autoplay failed:', error));

      // Event listener for when a track ends
      player.onended = playNextTrack;
    }
  }, [currentTrackIndex]);

  return (
    <div className="music-player-container">
      <AudioPlayer
        ref={audioRef}
        className="hidden-player"
        src={require(`../../assests/music/${musicList[currentTrackIndex]}`)}
        autoPlay
        controls
      />
    </div>
  );
};

export default MusicPlayer;
